import React from 'react';
import { CONTROL_LEASING_FEE } from 'server-sdk/src/constants';
import PricingOptionsWithSetup from 'src/components/app/PricingOptionsWithSetup';

export default function Pricing(): JSX.Element {
  return <PricingOptionsWithSetup price={CONTROL_LEASING_FEE} />;
}
